<template>
  <LayoutDashboard title="Contas a Receber">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarContaReceber"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-conta-receber')"
          >Cadastrar</v-btn
        >
        <v-btn
          color="default"
          v-if="!showFiltroAvancado"
          outlined
          class="ml-2"
          @click="showFiltroAvancado = true"
          >Filtro<v-icon right dark> search </v-icon>
        </v-btn>
        <v-btn
          color="default"
          v-if="showFiltroAvancado"
          outlined
          class="ml-2"
          @click="showFiltroAvancado = false"
          >Filtro<v-icon right dark> close </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getContasReceber.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getContasReceber.current_page"
          :length="getContasReceber.last_page"
          @input="listarContaReceber({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text v-if="showFiltroAvancado">
        <v-form ref="formFiltroContaReceber">
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-select
                class="mr-2 ml-2"
                :items="tiposPesquisas"
                v-model="tipoPesquisa"
                label="Pesquisar por:"
                outlined
                dense
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md3>
              <v-select
                :items="getContaReceberSituacoes"
                outlined
                dense
                v-model="dataPagina.situacao"
                label="Situação"
              ></v-select>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                class="mr-2 ml-2"
                outlined
                dense
                place
                type="date"
                label="Período Inicial"
                v-model="dataPagina.periodo_inicial"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-text-field
                class="mr-2 ml-2"
                outlined
                dense
                place
                type="date"
                label="Período Final"
                v-model="dataPagina.periodo_final"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 class="mr-2 ml-2">
              <v-btn color="success" outlined block @click="pesquisar()"
                >Filtrar
              </v-btn>
            </v-flex>
            <v-flex xs12 md12 class="mr-2 ml-2 mt-2">
              <v-btn color="primary" outlined block @click="imprimir()"
                >Imprimir
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    label="Cód."
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    label="Cliente"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">Valor</th>
                <th>Nº da Venda</th>
                <th width="13%">
                  <v-select
                    v-model="dataPagina.situacao"
                    outlined
                    dense
                    label="Situação"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    :items="getContaReceberSituacoes"
                  ></v-select>
                </th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.dataVencimento"
                    outlined
                    dense
                    label="Vencimento"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                    type="date"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-select
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="listarContaReceber({ ...dataPagina })"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="c in getContasReceber.data" :key="c.id">
                <td align="center">{{ c.id }}</td>
                <td>{{ c.cliente ? c.cliente.nome : "" }}</td>
                <td>{{ $helper.formatReal(parseFloat(c.valor - c.valor_pago)) }}</td>
                <td>{{c.venda_id ? c.venda_id : null}}</td>
                <td align="center">{{ c.situacao }}</td>
                <td align="center" :class="c.situacao == 'EM ABERTO' ? getCorVencimento(c.data_vencimento) : 'pago'">
                  {{ $helper.formatDate(c.data_vencimento) }}
                </td>
                <td>
                  <TooltipButton
                    @click.native="visualizarContaReceber(c)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-conta-receber')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-card-actions>
      <v-spacer></v-spacer>
      <h3>Registros: {{ getContasReceber.total }} -</h3>
      <v-pagination
        outlined
        total-visible="7"
        v-model="getContasReceber.current_page"
        :length="getContasReceber.last_page"
        @input="listarContaReceber({ ...dataPagina, page: $event })"
      ></v-pagination>
    </v-card-actions>
    <ModalCadastro />
    <ModalBaixa />
    <ModalCadastroLancamentoBancario />
  </LayoutDashboard>
</template>

<script>
import ModalCadastro from "@/pages/financeiro/contaReceber/ModalCadastro";
import ModalBaixa from "@/pages/financeiro/contaReceber/ModalBaixa";
import { mapGetters, mapActions } from "vuex";
import ModalCadastroLancamentoBancario from "@/pages/financeiro/lancamentoBancario/ModalCadastro";
import moment from "moment";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
    ModalBaixa,
    ModalCadastroLancamentoBancario,
  },
  data() {
    return {
      dataPagina: {
        id: "",
        cliente: "",
        dataVencimento: "",
        situacao: "EM ABERTO",
        limit: 20,
        page: "",
        periodo_inicial: "",
        periodo_final: "",
        content: "",
      },

      tiposPesquisas: ["Data de Vencimento"],
      tipoPesquisa: "Data de Vencimento",
      showFiltroAvancado: false,

      content: "",
      situacao: "",
    };
  },
  computed: {
    ...mapGetters([
      "getContasReceber",
      "getModalCadastroContaReceber",
      "getContaReceberSituacoes",
    ]),
  },
  methods: {
    ...mapActions([
      "listarContaReceber",
      "visualizarContaReceber",
      "cadastrarContaReceber",
      "listarPermissao",
      "setModalBaixaContaReceber",
    ]),

    getCorVencimento(_dataVencimento) {
      let dataAtual = moment().format("YYYY-MM-DD");
      let dataVencimento = moment(_dataVencimento);

      var diff = moment(dataVencimento, "YYYY-MM-DD").diff(
        moment(dataAtual, "YYYY-MM-DD")
      );
      let diferenca = moment.duration(diff).asDays();

      if (diferenca < 0) {
        return "vencido";
      } else if (diferenca == 0 || diferenca <= 5) {
        return "vencendo";
      } else if (diferenca > 0) {
        return "";
      }
    },

    imprimir() {
      this.listarContaReceber({
        ...this.dataPagina,
        limit: "",
        content: "pdf",
      });
    },
    pesquisar() {
      this.listarContaReceber({
        ...this.dataPagina,
        limit: 20,
        content: "json",
      });
    },
  },
  created() {
    this.listarContaReceber(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>

<style scoped>
.vencido {
  background-color: #ff938c;
}

.pago{
  background-color: #C1E9B9
}

.vencendo {
  background-color: #ffecb1;
}
</style>